import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BellRing } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { api, fmtDate, todayISO } from "@/lib/api";
import { followText, statusOf } from "@/lib/leads";

const Item = ({ id, title, sub, cls, onClick }) => (
  <Link to={`/admin/leads/${id}`} onClick={onClick} data-testid={`followup-bell-item-${id}`} className="block px-4 py-3 hover:bg-slate-50">
    <p className="text-sm font-medium text-navy">{title}</p><p className={`text-xs ${cls}`}>{sub}</p>
  </Link>
);

export const FollowUpBell = () => {
  const [data, setData] = useState({ followups: [], new_leads: [] });
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const load = () => api.get("/admin/crm/alerts").then((r) => setData(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  const total = data.followups.length + data.new_leads.length;
  const close = () => setOpen(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" aria-label="Lead alerts" data-testid="followup-bell"
          className="relative h-9 w-9 grid place-items-center rounded-lg border border-slate-200 text-slate-600 hover:text-ocean hover:border-ocean transition-colors">
          <BellRing className="h-4 w-4" />
          {total > 0 && <span data-testid="followup-bell-count" className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 rounded-full bg-coral text-white text-[10px] font-bold grid place-items-center">{total}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0 bg-white" data-testid="followup-bell-panel">
        <div className="max-h-96 overflow-y-auto">
          <p className="px-4 py-2.5 bg-slate-50 text-xs font-semibold uppercase tracking-wider text-navy" data-testid="bell-new-leads-title">New leads ({data.new_leads.length})</p>
          {data.new_leads.length === 0 ? <p className="px-4 py-3 text-xs text-slate-500">No new leads waiting.</p> : data.new_leads.map((l) => (
            <Item key={l.id} id={l.id} title={l.name} sub={`${l.what} · ${fmtDate(l.created_at)}`} cls="text-sky-700" onClick={close} />
          ))}
          <p className="px-4 py-2.5 bg-slate-50 text-xs font-semibold uppercase tracking-wider text-navy">Follow-ups due ({data.followups.length})</p>
          {data.followups.length === 0 ? <p className="px-4 py-3 text-xs text-slate-500">All caught up.</p> : data.followups.map((l) => {
            const late = l.follow_up_date < todayISO();
            return <Item key={l.id} id={l.id} title={l.name} sub={`${late ? "Overdue" : "Today"} · ${followText(l)} · ${statusOf(l.status).label}`} cls={late ? "text-rose-600" : "text-orange-700"} onClick={close} />;
          })}
        </div>
        <Link to="/admin/enquiries" onClick={close} className="block px-4 py-2.5 border-t border-slate-100 text-xs font-semibold text-ocean" data-testid="followup-bell-all">Open Leads</Link>
      </PopoverContent>
    </Popover>
  );
};
